import React from 'react';
import { Avatar, SxProps, Theme } from '@mui/material';
import { getImageSrc } from '../../../utils/photoUtils';

interface VisitorAvatarProps {
  photoUrl?: string | null;
  name: string;
  isActive: boolean;
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

const sizeMap = {
  small: 40,
  medium: 48,
  large: 64,
};

const VisitorAvatar: React.FC<VisitorAvatarProps> = ({
  photoUrl,
  name,
  isActive,
  size = 'medium',
  sx,
}) => {
  return (
    <Avatar
      // ✅ photoUrl может быть null → передаём undefined
      src={getImageSrc(photoUrl || undefined)}
      sx={{
        width: sizeMap[size],
        height: sizeMap[size],
        border: '2px solid',
        borderColor: isActive ? 'success.main' : 'divider',
        ...sx,
      }}
    >
      {name[0]}
    </Avatar>
  );
};

export default VisitorAvatar;
